import {combineReducers} from 'redux';
import viewStreamSummaryModal from './viewStreamSummaryModalReducer';

export default combineReducers({
  viewStreamSummaryModal,
});
